module.exports = __webpack_public_path__ + "img/07.a206f2b9.jpg";